export default "__VITE_ASSET__deefbf1d__"